import { createContext, useContext, useEffect, useRef, useState } from 'react';

import { Event } from '@bizzabo/entities';
import { Socket } from '@bizzabo/transport';
import config from 'config';

type ConnectSocket = {
    socket: Socket;
    isConnected: boolean;
};

const socketContext = createContext<ConnectSocket>(null);

type Props = {
    event: Event;
};

export const SocketProvider: React.FC<Props> = ({ event, children }) => {
    const [isConnected, setIsConnected] = useState(false);
    const ringSocket = useRef(
        new Socket({
            accountId: event.accountId,
            eventId: event.id,
            tokenCookieName: config.authCookieAccess + `-${event.groupId}`,
            baseUrl: config.realtimeNotificationsHost,
            refreshTokenUrl: config.refreshTokenUrl + `?eventGroupId=${event.groupId}`,
        })
    );

    useEffect(() => {
        const connect = async () => {
            try {
                await ringSocket.current.connect(event.accountId, event.id, null, {}, true);
                setIsConnected(true);
            } catch (e) {
                console.log(e.message);
            }
        };

        connect();

        return () => {
            ringSocket.current.close();
        };
    }, []);

    return (
        <socketContext.Provider value={{ socket: ringSocket.current, isConnected }}>
            {children}
        </socketContext.Provider>
    );
};

export const useSocket = () => useContext(socketContext);
